import { useQuery } from '@tanstack/react-query';
import { stringify as toQueryString } from '@AppModels/QueryStringUtils';
import { IDictionary } from '../../extViewmodels';
import { useApiClientContext } from '../../surveys/context';

export const GET_SURVEY_BY_TOKEN_QUERY_LOGO_KEY = 'getSurveyByTokenQuery/logo';

export const useClientGetSurveyLogoByToken = ({
	accessToken,
	enabled = true,
	refetchOnWindowFocus = false,
}: {
	accessToken?: string;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	options?: IDictionary<string>;
}) => {
	const { apiClient } = useApiClientContext();
	return useQuery({
		enabled,
		queryFn: () => {
			return apiClient.get<string>(`survey/byToken/logo?${toQueryString({ token: accessToken })}`);
		},
		queryKey: [GET_SURVEY_BY_TOKEN_QUERY_LOGO_KEY, accessToken],
		refetchOnWindowFocus,
	});
};
